import SystemInfo from "./pages/SystemInfo.vue";

export default {
    SystemInfo,
};
